<template>
  <div class="animated fadeIn">
    <b-row class="justify-content-center">
      <b-col lg="8" xl="6">
        <b-card>
          <div slot="header">
            ADD COMPANY PROFILE
            <div class="card-header-actions">
              <button
                v-if="saveEnabled"
                class="btn btn-primary mr-1"
                @click="save()"
              >
                <i class="fa fa-save"></i> Save
              </button>
              <button class="btn btn-danger mr-1" @click="close()">
                <i class="fa fa-close"></i> Close
              </button>
            </div>
          </div>
          <b-input-group>
            <b-input-group-prepend
              ><label>Company Name</label></b-input-group-prepend
            >
            <b-form-input
              v-model="model.company"
              :state="!$v.model.company.$error"
            ></b-form-input>
          </b-input-group>
          <b-input-group>
            <b-input-group-prepend
              ><label>Company Address</label></b-input-group-prepend
            >
            <b-form-input
              v-model="model.compaddr1"
              :state="!$v.model.compaddr1.$error"
            ></b-form-input>
          </b-input-group>
          <b-input-group>
            <b-input-group-prepend><label>&nbsp;</label></b-input-group-prepend>
            <b-form-input
              v-model="model.compaddr2"
              :state="!$v.model.compaddr2.$error"
            ></b-form-input>
            <b-form-input v-model="model.compaddr3" class="ml-1"></b-form-input>
          </b-input-group>
          <b-row>
            <b-col lg="8">
              <b-input-group>
                <b-input-group-prepend
                  ><label>Company Code</label></b-input-group-prepend
                >
                <b-form-input v-model="model.compcode"></b-form-input>
              </b-input-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="8">
              <b-input-group>
                <b-input-group-prepend
                  ><label>NPWP</label></b-input-group-prepend
                >
                <b-form-input
                  v-model="model.npwp"
                  :state="!$v.model.npwp.$error"
                ></b-form-input>
              </b-input-group>
            </b-col>
          </b-row>
          <b-input-group>
            <b-input-group-prepend
              ><label>NPWP Name</label></b-input-group-prepend
            >
            <b-form-input
              v-model="model.npwp_name"
              :state="!$v.model.npwp_name.$error"
            ></b-form-input>
          </b-input-group>
          <b-input-group>
            <b-input-group-prepend><label>City</label></b-input-group-prepend>
            <b-form-input
              v-model="model.compcity"
              :state="!$v.model.compcity.$error"
            ></b-form-input>
            <b-input-group-prepend
              ><span class="p-2">Current Periode </span></b-input-group-prepend
            >
            <b-form-input
              v-model="model.tanggal"
              type="date"
              :state="!$v.model.tanggal.$error"
            ></b-form-input>
          </b-input-group>
          <hr />
          <!-- <b-row>
                    <b-col lg="9"> -->
          <b-input-group>
            <b-input-group-prepend
              ><label>Copy from Company</label></b-input-group-prepend
            >
            <b-form-input
              v-model="model.fromcompany"
              readonly
              :state="!$v.model.fromcode.$error"
            ></b-form-input>
            <b-input-group-append>
              <b-btn text="Button" @click="lkuCompanyShow = true">
                <i class="fa fa-search"></i>
              </b-btn>
            </b-input-group-append>
            <button
              v-if="saveEnabled"
              class="btn btn-primary ml-2"
              @click="save()"
            >
              <i class="fa fa-save"></i> Save
            </button>
            <button class="btn btn-primary ml-1" @click="close()">
              <i class="fa fa-close"></i> Close
            </button>
          </b-input-group>
          <!-- </b-col>
                    <b-col lg="3">
                        <b-row>
                        </b-row>
                    </b-col>
                </b-row> -->
        </b-card>
      </b-col>
    </b-row>
    <b-modal
      v-model="lkuCompanyShow"
      size="lg"
      :hide-footer="true"
      title="List of Company"
      :centered="true"
    >
      <lku-company @click="onSelectLkuCompany"></lku-company>
    </b-modal>
  </div>
</template>
<style lang="scss">
.input-group {
  padding-bottom: 2px;
  .input-group-prepend {
    label {
      padding-top: 5px;
      width: 160px !important;
    }
  }
}
.aging-group {
  .card-body {
    padding: 0 !important;
  }
}
</style>

<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import moment from "moment";
import toastr from "mini-toastr";
import lkuCompany from "../lookup/lkuCompany";
import clients from "../../apis/clients";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
toastr.init();

export default {
  components: { Loading, lkuCompany },
  mixins: [validationMixin],
  validations: {
    model: {
      fromcode: { required },
      company: { required },
      compaddr1: { required },
      compaddr2: { required },
      compcity: { required },
      npwp: { required },
      npwp_name: { required },
      tanggal: { required },
    },
  },
  data() {
    return {
      saveEnabled: true,
      isLoading: false,
      currency: [{ value: "IDR", text: "IDR" }],
      model: {
        fromcode: "",
        compcode: "",
        company: "",
        compaddr1: "",
        compaddr2: "",
        compcity: "",
        npwp: "",
        npwp_name: "",
        tanggal: "",
      },
      lkuCompanyShow: false,
    };
  },
  computed: {
    invalidModel() {
      this.$v.model.$touch();
      return this.$v.model.$invalid;
    },
  },
  watch: {
    "model.tanggal": function (newval) {
      this.model.tglaktif = moment(newval).format("YYYY-MM-01");
      console.log("this.model.tglaktif: ", this.model.tglaktif);
    },
  },
  methods: {
    onSelectLkuCompany: async function (_selected) {
      this.model.fromcode = _selected.compcode;
      this.model.fromcompany = _selected.company;
      this.lkuCompanyShow = false;
    },
    save: async function () {
      this.isLoading = true;
      if (this.invalidModel) {
        console.log("validation : ", this.$v.model);
        console.log("model obj : ", this.model);
        toastr.error("Please fill the form correctly.", "ERROR MESSAGE");
        this.isLoading = false;
        this.close();
      } else {
        try {
          const company = { ...this.model };
          company.tglaktif = company.tanggal
            ? moment(company.tanggal).format("YYYY-MM-DD")
            : "";
          await clients.insert(company);
          toastr.success("Company Successfully Added");
          this.isLoading = false;
        } catch (error) {
          this.isLoading = false;
          console.log("error : ", error);
          if (error.sql) {
            toastr.error(error.sql, "ERROR MESSAGE", 10000);
          } else if (error.sqlMessage) {
            toastr.error(error.sqlMessage, "ERROR MESSAGE", 10000);
          } else if (error.message) {
            toastr.error(error.message, "ERROR MESSAGE", 10000);
          } else {
            toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
          }
          this.saveEnabled = true;
        }
      }
    },
    close() {
      router.push("home");
    },
  },
};
</script>
